import { render, staticRenderFns } from "./PreciosTratamientos.vue?vue&type=template&id=7008b1d6&scoped=true"
import script from "./PreciosTratamientos.vue?vue&type=script&lang=js"
export * from "./PreciosTratamientos.vue?vue&type=script&lang=js"
import style0 from "./PreciosTratamientos.vue?vue&type=style&index=0&id=7008b1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008b1d6",
  null
  
)

export default component.exports